var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f3",attrs:{"id":"FamilyChart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }